import React from "react";
import { useOutletContext } from "react-router-dom";
import { Note, PageHead, RailCard, DeskSupport, KeyValue } from "@/components/portal/crm/kit";
import { CrmCard } from "@/components/portal/CrmCard";
import { AdminPreviewBanner } from "@/pages/introducer/Portal";

export default function Crm() {
  const { me, isAdmin } = useOutletContext();

  return (
    <>
      {isAdmin && <AdminPreviewBanner what="lender desk" />}

      <PageHead
        eyebrow="Cases, where you already work"
        title="CRM delivery"
        lede="Connect your CRM and every case we route arrives as a live record, with stage changes syncing back to Connexis automatically."
        testId="lender-crm-head"
      />

      <div className="grid items-start gap-7 xl:grid-cols-[minmax(0,1fr)_320px]">
        <div className="min-w-0"><CrmCard /></div>
        <div className="space-y-4">
          <RailCard title="What gets sent" testId="lender-crm-what">
            <ul className="space-y-3 text-[12.5px] leading-relaxed text-slate-600">
              {[
                "The whole application — applicant, company, financials, the deal and the introducer's notes.",
                "Attached documents stay in the portal. We send the link, not the file, so nothing leaks into a CRM you share.",
                "Your stage changes come back to us, so moving it in your CRM moves it here.",
                "Never: who introduced the case, or which other desks hold it.",
              ].map((x) => <li key={x} className="flex gap-2.5"><span className="mt-[7px] size-1.5 shrink-0 rounded-full bg-[#0055FF]" />{x}</li>)}
            </ul>
          </RailCard>

          <RailCard title="Your desk" testId="lender-crm-desk">
            <KeyValue label="Delivery" value={(me?.delivery_method || "dashboard").replace(/_/g, " ")} />
            <KeyValue label="CRM" value={me?.crm?.provider ? `${me.crm.provider}${me.crm.enabled ? " · live" : " · off"}` : "Not connected"} />
          </RailCard>

          <DeskSupport body="Using something we don't list? Tell us what it is — most of them take a webhook and we'll wire it." />
          <Note>A failed hand-off is retried and then raised with the desk. You will never silently lose a case.</Note>
        </div>
      </div>
    </>
  );
}
